/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * User general meal preferences model for meal type
 */
export type GeneralsMealPreferencesMealType = {
  mealTypePreference: GeneralsMealPreferencesMealType.mealTypePreference;
};
export namespace GeneralsMealPreferencesMealType {
  export enum mealTypePreference {
    QUICK_AND_EASY = "quickAndEasy",
    COOK_FROM_SCRATCH = "cookFromScratch",
    BOTH = "both",
  }
}
